<div *ngIf="!loading">
  <div class="spinner"></div>
  <p class="text-center" style="color: #777;margin: -70px 0 100px;">Carregando solicitação, por favor aguarde ...
  </p>
</div>

<div *ngIf="loading" class="animated fadeIn">

  <div *ngIf="atualizar == 1">
    <div class="callout callout-info">
      <h4>Não houveram alterações nesta etapa!</h4>
    </div>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Quais Técnicas de Monitoramento e Avaliação serão aplicadas durante a execução do
            objeto:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ monitoramentoAvaliacao.tecnicaMonitoramento }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Sustentabilidade da Proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ monitoramentoAvaliacao.sustentabilidadeProposta }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <div class="callout callout-info">
      <h4>Não houveram alterações nesta etapa!</h4>
    </div>
  </div>

  <mat-tab-group *ngIf="atualizar == 0">

    <mat-tab label="Antes">
      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Quais Técnicas de Monitoramento e Avaliação serão aplicadas durante a execução do
              objeto:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ monitoramentoAvaliacao.tecnicaMonitoramento }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Sustentabilidade da Proposta:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ monitoramentoAvaliacao.sustentabilidadeProposta }}</p>
        </mat-card-content>
      </mat-card>

      <br>

    </mat-tab>

    <mat-tab label="Depois">
      <br>
      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Quais Técnicas de Monitoramento e Avaliação serão aplicadas durante a execução do
              objeto:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ monitoramentoAvaliacaoAlterado.tecnicaMonitoramento }}</p>
        </mat-card-content>
      </mat-card>

      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title><label>Sustentabilidade da Proposta:</label></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>{{ monitoramentoAvaliacaoAlterado.sustentabilidadeProposta }}</p>
        </mat-card-content>
      </mat-card>

      <div class="callout callout-info">
        <h4>Avaliação da alteração!</h4>
        <div class="ui-g-12 ui-fluid">
          <div class="form-group">
            <div class="radio">
              <label>
                <input type="radio" name="optionsRadios" id="optionsRadios1" (click)="aprovado()">Aprovado
              </label>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <label>
                <input type="radio" name="optionsRadios" id="optionsRadios3" (click)="reprovado()">Reprovado
              </label>
            </div>
          </div>

        </div>

        <textarea [(ngModel)]="alterMonitoramentoAvaliacao.justifAvalAlteracao" class="form-control" rows="3"
          placeholder="Observação ..."></textarea><br>
        <button (click)="finalizarAvaliacao()" type="button" class="btn btn-sm btn-default">AVALIAR</button>
      </div>


    </mat-tab>

  </mat-tab-group>


  <div *ngIf="atualizar == 2">
    <div class="callout callout-info">
      <h4>
        Etapa já avaliada!
        <span style="float: right;"><button (click)="alterarAvaliacao()" type="button"
            class="btn btn-sm btn-default">ALTERAR AVALIAÇÃO</button></span>
      </h4>
    </div>
    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Quais Técnicas de Monitoramento e Avaliação serão aplicadas durante a execução do
            objeto:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ monitoramentoAvaliacao.tecnicaMonitoramento }}</p>
      </mat-card-content>
    </mat-card>

    <br>

    <mat-card>
      <mat-card-header>
        <mat-card-title><label>Sustentabilidade da Proposta:</label></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ monitoramentoAvaliacao.sustentabilidadeProposta }}</p>
      </mat-card-content>
    </mat-card>
    
    <br>
    <div class="callout callout-info">
      <h4>
        Etapa já avaliada!
        <span style="float: right;"><button (click)="alterarAvaliacao()" type="button"
            class="btn btn-sm btn-default">ALTERAR AVALIAÇÃO</button></span>
      </h4>
    </div>
  </div>



</div>